import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as bookingHelpers from '../util/bookingHelpers';
import { roundToPreviousPeriod, roundToNextPeriod } from '../util';
import {
    START_TIME,
    END_TIME,
} from '../constants/timelineFocusPoints';
import { MINUTES_IN_BLOCK } from  '../components/Common/TimeSelector/TimeGrid';
import TimeSelector from '../components/Common/TimeSelector/TimeSelector';

import { fetchUnavailableTimes } from '../actions/entities';
import { setError } from '../actions/environment';

class EditBookingTimeSelectorContainer extends Component {
    static propTypes = {
        booking: PropTypes.object.isRequired,
        focusPoint: PropTypes.number.isRequired,
        unavailableTimes: PropTypes.object,
        currentAvailabilityWindow: PropTypes.object,
        fetchUnavailableTimes: PropTypes.func.isRequired,
        onSave: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
        setError: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.state = this.calculateState(props);
    }

    componentWillMount() {
        // Fetch unavailable times if we don't have them for this booking
        if (!this.props.unavailableTimes) {
            const { versionedUId, staticUId } = this.props.booking;
            this.props.fetchUnavailableTimes(versionedUId, staticUId);
        }
    }

    componentDidUpdate() {
        if (this.props.currentAvailabilityWindow && !this.props.currentAvailabilityWindow.valid)
            this.props.onClose();
    }

    componentWillReceiveProps(nextProps) {
        if (
            this.props.currentAvailabilityWindow !== nextProps.currentAvailabilityWindow ||
            this.props.booking.versionedUId != nextProps.booking.versionedUId
        ) {
            this.setState(this.calculateState(nextProps));
        }
    }

    calculateState(props) {
        const { booking, focusPoint, currentAvailabilityWindow } = props;

        let roundedMinStart;
        let roundedMaxEnd;
        if (currentAvailabilityWindow && currentAvailabilityWindow.valid) {
            roundedMinStart = roundToNextPeriod(currentAvailabilityWindow.minStartDate, MINUTES_IN_BLOCK);
            roundedMaxEnd = roundToPreviousPeriod(currentAvailabilityWindow.maxEndDate, MINUTES_IN_BLOCK);
        }

        const { start, end } = bookingHelpers.getStartEndTimesBasedOnBookingStatus(booking);
        const roundedStart = roundToPreviousPeriod(start, MINUTES_IN_BLOCK);
        const roundedEnd= roundToNextPeriod(end, MINUTES_IN_BLOCK);

        return {
            initialStart: start,
            initialEnd: end,
            roundedStart,
            roundedEnd,
            roundedMinStart,
            roundedMaxEnd,
            focusTime: focusPoint === START_TIME ? start : end,
        };
    }

    render() {
        const shouldDisplayTimeSelector = this.props.currentAvailabilityWindow && this.props.currentAvailabilityWindow.valid;

        return shouldDisplayTimeSelector ? (
            <TimeSelector
                initialStart={this.state.initialStart}
                initialEnd={this.state.initialEnd}
                roundedStart={this.state.roundedStart}
                roundedEnd={this.state.roundedEnd}
                roundedMinStart={this.state.roundedMinStart}
                roundedMaxEnd={this.state.roundedMaxEnd}
                initialFocusTime={this.state.focusTime}
                canEditStart={this.props.unavailableTimes.canEditStartTime}
                canEditEnd={this.props.unavailableTimes.canEditEndTime}
                onSave={this.props.onSave}
                onClose={this.props.onClose}
                startTimeUnavailabilityReasons={this.props.currentAvailabilityWindow.startTimeUnavailabilityReasons}
                endTimeUnavailabilityReasons={this.props.currentAvailabilityWindow.endTimeUnavailabilityReasons}
                onUnavailableTimeSlotClicked={this.props.setError}
            />
        ) : null;
    }
}

function mapStateToProps(state, ownProps) {
    const { currentAvailabilityWindows, unavailableTimes } = state.entities;
    const bookingUnavailableTimes = unavailableTimes[ownProps.booking.staticUId];
    const bookingAvailabilityWindow = currentAvailabilityWindows[ownProps.booking.staticUId];

    return {
        unavailableTimes: bookingUnavailableTimes,
        currentAvailabilityWindow: bookingAvailabilityWindow,
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        fetchUnavailableTimes,
        setError,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(EditBookingTimeSelectorContainer);



// WEBPACK FOOTER //
// ./scripts/containers/EditBookingTimeSelectorContainer.jsx